import { BoardMember } from '../types/task';
import { MemberRole } from '../contract';

// How a change to a board's member list turns it into its next version: a new list, the original untouched, with no
// React or network in it, so it can be tested directly. data/members.ts applies it to the cache.

// The role and kiosk setting of one member. A list that doesn't have them (or isn't loaded) comes back unchanged.
export const withMemberAccess = (members: BoardMember[] | undefined, memberId: string, role: MemberRole, kiosk: boolean) =>
    members?.map((member) => (member.id === memberId ? { ...member, role, kiosk } : member));
